import { Module } from "vuex";

import { NekoState } from "@/lib/vuex/typings";

import { AuditContext, Context, ContextState } from "../typings";
import { AuditRepresentation } from "@/lib/apis/replicable/models";
import AuditsResourceApi from "@/lib/apis/replicable/operations/AuditsResourceApi";

export const localStorageKey = "audit-context";
export const prefixLocalStorageAudit = "audit-id-";
export const prefixLocalStorageYear = "year-";

export function getInitialContext(): Context {
	const storedContext = localStorage.getItem(localStorageKey);
	let year: number = new Date().getFullYear();

	if (storedContext && storedContext.startsWith(prefixLocalStorageYear)) {
		year = parseInt(storedContext.substring(prefixLocalStorageYear.length));
	}

	return { year };
}

function storeContext(context: Context) {
	if (!context) {
		return;
	}

	if (context instanceof AuditContext) {
		localStorage.setItem(localStorageKey, prefixLocalStorageAudit + context.audit.id);
	} else {
		localStorage.setItem(localStorageKey, prefixLocalStorageYear + context.year);
	}
}

export default {
	namespaced: true,

	state: {
		selected: getInitialContext()
	},

	getters: {
		year(state) {
			return state.selected?.year;
		},
		audit(state) {
			if (!(state.selected instanceof AuditContext)) {
				return null;
			}

			return state.selected.audit;
		}
	},

	mutations: {
		chooseAudit(state: ContextState, audit: AuditRepresentation) {
			state.selected = new AuditContext(audit);
			storeContext(state.selected);
		},

		chooseYear(state: ContextState, year: number) {
			if (!(state.selected instanceof AuditContext)) {
				state.selected = { year };
				storeContext(state.selected);
			}
		},

		deleteContext(state: ContextState) {
			const newContext: Context = { year: state.selected.year };

			if (state.selected instanceof AuditContext) {
				localStorage.removeItem(localStorageKey);
				storeContext(newContext);
			}

			state.selected = newContext;
		}
	},

	actions: {
		async refreshAudit(context) {
			context.commit("chooseAudit", await AuditsResourceApi.get(context.getters["audit"].id));
		}
	}
} as Module<ContextState, NekoState>;
